import React from 'react';
import { Brain, Zap, Code, Database, BarChart, Shield } from 'lucide-react';
import './CrawlingChatbotLandingPage.css';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import { useMediaQuery } from '@mui/material';

const features = [
  {
    icon: <Brain className="icon" />,
    title: 'Enter Website URL',
    description: 'Provide the website link you want the system to crawl and extract information from.'
  },
  {
    icon: <Zap className="icon" />,
    title: 'Smart Crawling Engine',
    description: 'Our engine automatically scans pages, extracts useful content, and removes noise.'
  },
  {
    icon: <Code className="icon" />,
    title: 'Train the Chatbot',
    description: 'The extracted data is processed and converted into embeddings to train your chatbot.'
  },
  {
    icon: <Database className="icon" />,
    title: 'Create a Knowledge Base',
    description: 'Your website’s text, FAQs, and important details are stored securely for fast responses.'
  },
  {
    icon: <BarChart className="icon" />,
    title: 'Embed on Your Website',
    description: 'Get a ready-to-use chatbot widget that you can directly embed in your website.'
  },
  {
    icon: <Shield className="icon" />,
    title: 'Secure & Private',
    description: 'Your data stays protected and is used only for generating accurate chatbot answers.'
  },
];

const CrawlingChatbotLandingPage = () => {
  const navigate = useNavigate();

  const onClickHandle = () => {
    navigate('/crawling/signin');
  };

  const isCustomSize = useMediaQuery("(max-width:770px)");

  return (
    <>
      <Header />
      <div className="crawlingChatbot" style={{ padding: '30px' }}>
        <div className="container">
          <div className="wrapper">

            {/* Hero Section */}
            <div className="hero">
              <h1 className="hero-title">
                Smart AI <span className="highlight">Virtual Assistance</span>
              </h1>
              <p className="hero-description">
                Build a smart AI-powered chatbot trained directly from your website’s content. 
                Just enter a URL — our system automatically crawls the site, extracts text, 
                creates a knowledge base, and generates a chatbot you can embed anywhere.
              </p>
            </div>

            {/* Features */}
            <div className="features-box">
              {!isCustomSize && (
                <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                  <h2 className="features-heading">How It Works</h2>
                  <h2 className="features-heading">What We Do</h2>
                </div>
              )}

              {isCustomSize && (
                <h2 style={{ fontSize: '22px' }} className="features-heading">
                  What This AI Utility Does
                </h2>
              )}

              <div className="features-grid">
                {features.map((feature, idx) => (
                  <FeaturePoint key={idx} {...feature} />
                ))}
              </div>
            </div>

            {/* CTA */}
            <div className="cta">
              <button onClick={onClickHandle} className="cta-button">
                Try Smart AI Virtual Assistance Now
              </button>
              <p className="cta-note">
                No setup required • Works with any website • Easy to embed
              </p>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

const FeaturePoint = ({ icon, title, description }) => (
  <div className="feature-point">
    <div className="icon-container">{icon}</div>
    <div>
      <h3 className="feature-title">{title}</h3>
      <p className="feature-description">{description}</p>
    </div>
  </div>
);

export default CrawlingChatbotLandingPage;
